app.directive('weightConverter', function($window, $document, throttle) {
    return {
        restrict: 'A',
        scope: {
            from: '@from'
        },
        link: function($scope, $element) {
            if ($scope.from == 'view-customer') {
                const $weightContainer = $element.find('#weight-text');
                const weight = $weightContainer.attr('data-weight');
                if (!weight) {
                    return;
                }
                $element.find('select').on('change', function(e) {
                    const selectedUnit = e.target.value;
                    const previousUnit = e.target.dataset.unit || '';
    
                    if (!selectedUnit || selectedUnit === previousUnit) {
                        return;
                    }
    
                    const ratio = selectedUnit.toLowerCase() === 'kg' ? 0.453592 : 2.20462;
                    const currentWeight = $weightContainer.attr('data-weight');

                    const convertedWeight = Math.round(currentWeight * ratio * 100) / 100;
                    $weightContainer.text(convertedWeight);
                    $weightContainer.attr('data-weight', convertedWeight);
                    e.target.dataset.unit = selectedUnit;
                });
            } else {
                const $weightInput = $element.parents('form').find('#profile_edit_weightInPreferredUnit');
    
                if (!$weightInput.length) {
                    return;
                }
    
                $weightInput.parent().append('<div class="sg-weight-input-unit-placeholder"></div>');
                $weightInput.parent().addClass('sg-weight-input');
                const $unitPlaceholder = $weightInput.parent().find('.sg-weight-input-unit-placeholder');
                updateUnitPlaceholder($unitPlaceholder, $element.val());
    
                $element.on('change', function(e) {
                    const selectedUnit = e.target.value;
                    const previousUnit = e.target.dataset.unit || '';
    
                    if (!selectedUnit || selectedUnit === previousUnit) {
                        return;
                    }
    
                    const ratio = selectedUnit.toLowerCase() === 'kg' ? 0.453592 : 2.20462;
                    const currentWeight = $weightInput.val();
    
                    $weightInput.val(Math.round(currentWeight * ratio * 100) / 100);
                    e.target.dataset.unit = selectedUnit;
    
                    updateUnitPlaceholder($unitPlaceholder, e.target.value);
                });
            }
            
            function updateUnitPlaceholder($unitPlaceholder, value) {
                $unitPlaceholder.html(value);
            }
        }
    };
});
